<template>
  <div class="tab">
      <ul slot="header" class="tab-header">
        <li v-for="(item, index) in tabData"
            :key="item.id"
            :class="{'tab-header-item-active': index === currentIndex}"
            class="tab-header-item"
            @click="handleSwitch(index)">
            {{ item.name }}
        </li>
      </ul>
      <RenderFun :render-fun="renderTabItemFun"></RenderFun>
  </div>
</template>

<script>
import RenderFun from '@/components/renderFun/RenderFun'
export default {
  name: 'Tab',
  components: {
    RenderFun
  },
  data () {
    return {
      currentIndex: 0,
    }
  },
  computed: {
    renderTabItemFun () {
      return (h) => {
        return this.renderFun(h, this.tabData[this.currentIndex], this.currentIndex)
      }
    }
  },
  props: {
    tabData: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    renderFun: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleSwitch (index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/style/styleMixins";
  .tab{
    &-header{
      .flex_justify_center_mixins;
      padding: 25px 0;
      &-item{
        margin-right: 54px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        position: relative;
        cursor: pointer;
        &-active{
          &::before{
            content: '';
            display: block;
            position: absolute;
            bottom: -10px;
            left: 5px;
            right: 5px;
            height: 4px;
            background: #3D6BFF;
            border-radius: 2px
          }
        }
      }
    }
  }
</style>
